import { TenantProfileLayout } from "../../../TenantProfile"
import { Outlet } from "react-router"

export default function Layout() {
	return (
		<TenantProfileLayout>
			<Outlet />
		</TenantProfileLayout>
	)
}
